module.exports = __webpack_public_path__ + "img/bg_04.4824bae1.png";